export default {
sets: `Sets`,
stats: `Statistiken`,
discover: `Entdecken`,
guides: `Führer`,
settings: `Einstellungen`,
unsupportedBrowserBody: `Flashcards unterstützt diesen Browser nicht. Laden Sie die neueste Version von Chrome oder Opera herunter oder laden Sie unser iPhone- oder Android -Anwendung herunter`,
unsupportedBrowserTitle: `Nicht unterstützter Browser`,
noData: `Keine Daten zu zeigen`,
contactUsTitle: `Wir lieben es, zu hören, wie unsere Benutzer unsere App nutzen und wie wir uns verbessern können. Schreiben Sie uns eine Nachricht mit Abfragen wie Feature -Anfragen oder Fehlerberichten`,
rateAppStore: `Rate in AppStore`,
rateGoogle: `Rate in Google Play`,
close: `Schließen`,
shareFriends: `Mit Freunden teilen`,
noCardsQ: `Sie haben keine Karteikarten?`,
noCardsS: `Wählen Sie aus unserer Sammlung aus, um loszulegen`,
suggestSet: `Set vorschlagen`,
createOwn: `Erstelle dein eigenes`,
search: `Suche`,
loading: `Wird geladen`,
words: `Wörter`,
downloads: `Downloads`,
export: `Export`,
import: `Importieren`,
importing: `Importieren ... schließen Sie die App nicht`,
importPreview: `Vorschau importieren`,
howQuizlet: `Wie man aus Quizlet importiert`,
cards: `Karten`,
importPreviewStatus: `__ Begriffe sind bereit, an die vorhandenen ___ Karten beigefügt zu werden`,
importPaste: `Fügen Sie Ihre Karten in das obige Textbereich ein`,
setTotalLimitReached: `Sie können nur 3000 Karten in einem Studyset haben`,
studying: `Studium`,
learnt: `Gelernt`,
mastered: `Gemeistert`,
new: `Neu`,
noTerm: `Kein Begriff`,
noDef: `Keine Definition`,
cardSaved: `Karte gespeichert`,
reviews: `Bewertungen`,
practices: `Praktiken Methoden Ausübungen`,
flashcards: `Karteikarten`,
alerts: `Warnungen`,
corrects: `Korrigiert`,
mistakes: `Fehler`,
reviewCycle: `Überprüfungszyklus`,
reviewsLeft: `Bewertungen übrig`,
lastReview: `Letzte Bewertung`,
nextReview: `Nächste Bewertung`,
hideHistory: `Volle Geschichte verstecken`,
showHistory: `Volle Geschichte zeigen`,
strength: `Stärke`,
star: `Stern`,
image: `Bild`,
tag: `Schild`,
added: `hinzugefügt`,
removed: `ENTFERNT`,
reviewedFrom: `Bewertet von __`,
notifications: `Benachrichtigungen`,
reviewedPractice: `Überprüft __ von ___ Praxis`,
successfully: `erfolgreich`,
unsuccessfully: `vergeblich`,
termUpdated: `Begriff aktualisiert`,
defUpdated: `Definition aktualisiert`,
flashcardCreated: `FlashCard erstellt`,
dropboxImage: `Sie müssen Dropbox Sync aktivieren, um Bilder hinzuzufügen`,
deleteImgConfirm: `Sind Sie sicher, dass Sie dieses Bild löschen möchten?`,
uploading: `Hochladen`,
save: `Speichern`,
uploadImageFail: `Image nicht hochladen`,
imageUploaded: `Bild hochgeladen`,
setNotFound: `Studyset nicht gefunden!`,
notEnoughCards: `Nicht genug Karten!`,
of: `__ von ___`,
on: `Auf`,
off: `aus`,
auto: `Automatisch`,
manual: `Handbuch`,
pronounce: `Aussprechen`,
practiceCompleted: `Sie haben diese Praxis abgeschlossen`,
closePractice: `Enge Praxis`,
autoplay: `Automatisches Abspielen`,
secFlipSecNext: `__ Sec Flip, ___ Sec Weiter`,
autopronounce: `Autopronounce`,
onlyTerm: `Nur Begriff`,
onlyDef: `Nur Definition`,
termAndDef: `Begriff und Definition`,
savePractice: `Übung retten?`,
continueLater: `Später fortsetzen`,
deletePractice: `Praxis löschen`,
term: `Begriff`,
def: `Definition`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Überprüfungsziel`,
dailyGoal: `Tägliches Ziel`,
edit: `Bearbeiten`,
setUp: `Aufstellen`,
noRecentPractice: `Sie haben keine letzten Praktiken`,
continueLastReview: `Letzte Bewertung fortsetzen`,
dueCards: `Fällige Karten`,
studyNow: `Lerne jetzt`,
newCards: `Neue Karten`,
terms: `Bedingungen`,
defs: `Definitionen`,
validCardsOf: `Nur __ der ausgewählten ___ Karten können praktiziert werden, da den anderen entweder den Begriff oder die Definition fehlt`,
reviewCards: `Überprüfungskarten`,
customizePractice: `Praxis anpassen`,
next: `Nächste`,
iWasRight: `Ich lag richtig`,
printProAlert: `Bitte kaufen Sie ein Pro -Abonnement, um mehr als 20 Karteikarten zu drucken`,
print: `Drucken`,
printWidth: `Term-Def-Breite`,
printFont: `Schriftgröße`,
printBorder: `Grenze`,
printMargin: `Seitenrand`,
printPadding: `Wortpolsterung`,
preparingFile: `Datei vorbereiten`,
notificationsBlocked: `Benachrichtigungen sind nicht aktiviert. Sie aktivieren Benachrichtigungen aus den Einstellungen Ihres Telefons`,
ranOutOfWords: `Rannte keine Karten aus, starten Sie die Praxis neu, um von vorne zu beginnen`,
ranOutOfWordsShort: `Aus den Worten ausgehen`,
ranOutOfWordsBody: `Öffnen Sie die App, um neue Wörter zu planen`,
proIncreaseNotifications: `Sie können die Gesamtbenachrichtigungen von 10 auf 50 in der Premium -Version erhöhen.`,
schedule: `Plan`,
frequency: `Frequenz`,
mode: `Modus`,
tM1: `1 Minute`,
tM2: `2 Minuten`,
tM5: `5 Minuten`,
tM10: `10 Minuten`,
tM15: `15 Minuten`,
tM30: `30 Minuten`,
tH1: `1 Stunde`,
tH2: `2 Stunden`,
termPassive: `Begriff passiv`,
termActive: `Begriff aktiv`,
defPassive: `Def Passiv`,
defActive: `Defaktiv`,
scheduledIn: `In __ mins geplant`,
scheduledAlertsProT: `Erhöhen Sie die Planbaren Warnungen mit Pro`,
scheduledAlertsProB: `Sie können die geplanten Warnungen mit dem Pro -Paket von 10 auf 50 erhöhen`,
seeFeatures: `Siehe Funktionen`,
defAndTerm: `Definition und Begriff`,
termHoldDef: `Begriff, die Definition enthüllen`,
defHoldTerm: `Definition, halten Sie den Begriff auf`,
notificationType: `Benachrichtigungstyp`,
copyToClipboard: `In die Zwischenablage kopieren`,
enterAuthCode: `Bitte geben Sie Ihren Autorisierungscode ein`,
invalidCode: `Ungültiger Code bereitgestellt`,
copied: `Kopiert!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Tippen Sie auf, um alle Premium -Funktionen zu entdecken, um in Ihrem eigenen Tempo effizienter zu erfahren`,
promoBtn: `Entdecken Sie alle Funktionen`,
setDropboxH2: `Dropbox -Synchronisierung`,
setDropboxPOff: `Aktivieren Sie die Dropbox -Synchronisierung, um Ihre Sets, Karteikarten, Tags und Fortschritte aufzubewahren, die auf allen Ihren Geräten gesichert und aktualisiert werden.`,
setDropboxPOn: `Ihre Daten werden gesichert und auf Ihren Geräten synchronisiert.`,
setDropboxBtn: `Synchronisation`,
status: `Status`,
syncNow: `Jetzt synchronisieren`,
contact: `Kontakt`,
contactUs: `Kontaktiere uns`,
useFromBrowser: `Verwenden Sie aus dem Browser`,
useFromBrowserMsg: `Besuchen Sie FlashCardsMadesImple.com auf Ihrem Computer und stellen Sie Ihre Karten wieder her und Lizenz, indem Sie die Dropbox -Synchronisierung aktivieren`,
termsPrivacy: `Begriffe & Privatsphäre`,
dailyReviewGoal: `Tägliches Überprüfungsziel`,
numberTerms: `Anzahl der Begriffe`,
selectTerm: `Wählen Sie mit dem Begriff Hinweis`,
selectDef: `Wählen Sie mit Definitionshinweise`,
pronounceTerm: `Mit dem Begriff Hinweis aussprechen`,
pronounceDef: `Aussprechen mit Definitionshinweis`,
typeTerm: `Tippen Sie mit dem Begriff Hinweis`,
typeDef: `Tippen Sie mit Definitionshinweise`,
quizTypes: `Bevorzugte Quiz -Typen`,
spacedRepetition: `Abstandsplan für den Abstand`,
spacedRepetitionP: `Mit der Wiederholung von Spaced können Sie Wörter mit weniger Anstrengungen beherrschen, indem Sie die Überprüfungszeit schrittweise abgeben. Der Standardplan beträgt 1-3-7-15-31 Tage, aber Sie können auch eine benutzerdefinierte Einrichtung einrichten.`,
spacedRepetionScheduleItem: `__ Tage nach ___ Bewertung (Tag ____)`,
atLeastOneSchedule: `Mindestens ein Zeitplan ist erforderlich`,
revisionLimitReached: `Sie erreichten die maximale Revisionsanzahl`,
addReviewSchedule: `Neuen Bewertungsplan hinzufügen`,
autoMarkLearnt: `Automatische Marke danach gelernt`,
autoMarkMastered: `Auto Mark danach gemeistert`,
tagManager: `Tag Manager`,
delete: `Löschen`,
addTag: `Neues Tag hinzufügen`,
tagDeletionH: `Tag Löschung`,
tagDeletionP: `Sind Sie sicher, dass Sie dieses Tag löschen möchten?`,
cancel: `Absagen`,
daysAfterLastReview: `Tage nach der letzten Bewertung`,
linkDropbox: `Link Dropbox`,
startSync: `Synchronisieren Sie Synchronisation`,
starred: `Sterne`,
images: `Bilder`,
tags: `Stichworte`,
types: `Typen`,
activeDays: `Aktive Tage`,
inactiveDays: `Inaktive Tage`,
longestStreak: `Längste Strähne`,
dailyGoalsCompleted: `Tägliche Ziele abgeschlossen`,
dailyGoalsFailed: `Die täglichen Ziele scheiterten`,
typePairs: `Typpaare`,
reviewTypes: `Überprüfungsarten`,
typePractice: `Typ Praxis`,
pronouncePractice: `Aussprechenpraxis`,
selectPractice: `Wählen Sie Übung`,
notificationReview: `Benachrichtigungsprüfung`,
flashcardReview: `Flashcard -Bewertung`,
studyset: `Studyset`,
enterStudysetName: `Bitte geben Sie einen Namen für Ihr Studyset ein`,
studysetName: `Geben Sie den Namen des SET ein`,
termType: `Term Typ / Lang`,
defType: `Definitionstyp / Lang`,
exportCards: `Exportkarten`,
importCards: `Karten importieren`,
quiz: `Quiz`,
showingOutOfCards: `__ aus ___ Karten herausstellen`,
showingAllCards: `Zeigen Sie alle Karten an, geben Sie in die obige Suchleiste ein oder tippen Sie auf alle Tags zum Filter`,
recording: `Aufzeichnung`,
downloadSet: `Zu meinen Sätzen hinzufügen`,
addNewCard: `Neue Karte hinzufügen`,
saveStudyset: `Save Study Set`,
studysetDeletionH: `Studyset -Löschung`,
studysetDeletionP: `Sind Sie sicher, dass Sie dieses Studyset löschen möchten, dies löscht auch alle enthaltenen Karten.`,
cardDeletionH: `Kartenlöschung`,
cardDeletionP: `Sind Sie sicher, dass Sie diese Karte löschen möchten?`,
cardLimitReached: `Sie können nur 3000 Karten in einem Studyset haben`,
limitExceeded: `Limit überschritten`,
atLeastTenCards: `Fügen Sie mindestens 10 Karten hinzu, um mit den Übungen zu beginnen`,
searchInAll: `Suche in allen Studiensätzen`,
noMatch: `Keine Übereinstimmung`,
atLeastThreeChars: `Geben Sie mindestens 3 Zeichen zur Suche ein`,
noSets: `Keine Sets`,
startingSync: `Synchronisation beginnen`,
noSetsP: `Wählen Sie aus den folgenden Optionen, um loszulegen`,
startingSyncP: `Wir erhalten Ihre Daten von Dropbox, dies kann eine Weile dauern`,
createNewStudyset: `Erstellen Sie ein neues Studyset`,
restoreFromBackup: `Stellen Sie die Sicherungsdatei wieder her`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Wählen Sie Übentyp`,
noDueCards: `Noch keine fälligen Karteikarten, Flashkarten, die Sie zuvor überprüft haben`,
noNewCards: `Keine neuen Karten zum Lernen`,
subscriptionH: `Kaufen Sie Pro, um alle Funktionen zu genießen und die kontinuierliche Entwicklung zu unterstützen.`,
buyLifetimePro: `Kaufen Sie Lifetime Pro für __`,
restorePurchase: `Kauf wiederherstellen`,
termsPrivacyC: `Bedingungen & Datenschutzrichtlinie`,
licenceShare: `Wenn Sie eine Lizenz von einem anderen Gerät gekauft haben, können Sie sie mit diesem Gerät freigeben, indem Sie die Dropbox -Synchronisierung auf beiden Geräten aktivieren`,
enterTagName: `Geben Sie den Namen des Tags ein`,
invalidName: `Ungültiger Name`,
create: `Erstellen`,
name: `Name`,
tagName: `Name Ihres Tags`,
color: `Farbe`,
back: `Zurück`,
rowSeparator: `Reihenabscheider`,
termDefSeparator: `Begriff - Def -Trennzeichen`,
output: `Ausgabe`,
inputCards: `Eingabekarten`,
review: `Überprüfung`,
language: `Sprache`,
archiveReversible: `Archiv (reversibel von Einstellungen)`,
deletePermanent: `Löschen (irreversibel)`,
archivedCards: `Archivierte Karten`,
masteredCards: `Meisterkarten`,
due: `Fällig`,
reviewed: `Überprüft`,
markReviewed: `Mark Reviewed`,
markMastered: `Mark gemeistert`,
forXYCards: `Für __ ___ Karten`,
createdAtSortBy: `Erstellungsdatum`,
lastReviewedSortBy: `Letzte Überprüfungsdatum`,
reviewCountSortBy: `Anzahl der Bewertungen`,
strengthSortBy: `Stärke`,
termSortBy: `Alphabetischer Begriff`,
definitionSortBy: `Alphabetische Def.`,
ascSortBy: `Aufsteigend`,
descSortBy: `Absteigend`,
featureSync: `Studieren Sie irgendwo, überall und jederzeit mit Ihren Flitzkarten auf allen Geräten synchronisiert`,
featureSpacedrepetition: `Schauen Sie sich Ihren allgemeinen Fortschritt an und üben Sie wieder, was Sie zum Üben benötigen`,
featureNotifications: `Bewegen Sie Ihr Lernen, ohne die App mit flexiblen Benachrichtigungen zu öffnen`,
featureFlashcards: `Autoplay -Karteikarten, wenn Ihre Hände oder Augen beschäftigt sind, aber Sie haben immer noch ungenutzte Aufmerksamkeit`,
featureQuiz: `Übereinstimmen, buchstabieren, anhören oder wählen, um Ihre Karteikarten zu üben`,
featureStats: `Gewinnen Sie einen besseren Einblick in Ihre Karten und Ergebnisse und suchen`,
featureImport: `Wir werden niemals Daten von Ihnen speichern und Sie können alle Ihre Daten problemlos exportieren und importieren`,
featurePrint: `Machen Sie etwas Lernen durch Drucken Ihrer Flitzkarten und DIY Ihr eigenes Lern ​​-Rig`,
splashIntro: `Studieren Sie alle Ihre Karteikarten überall in Ihrem Tempo und Stil`,
selectSortOrder: `Sortierreihenfolge`,
selectSortProp: `Sortieren Sie Eigentum`,
applyFilters: `Filter anwenden`,
selectSetType: `Was möchten Sie üben?`,
getStarted: `Loslegen`,
tapToUnarchive: `Tippen Sie auf die Karten, die Sie nicht anarchivieren möchten`,
untitled: `Ohne Titel`,
sortHintNew: `Sie werden die Karten sehen, die vor der längsten Zeit zuerst erstellt wurden`,
sortHintDue: `Sie werden Karten sehen, die zuerst am längsten fällig waren`,
sortHintOther: `Sie werden Karten sehen, die zuerst nicht am längsten untersucht wurden`,
flashcardsWhen: `, wenn Ihre Hände oder Augen beschäftigt sind, auch wenn Sie Musik / Podcasts hören`,
notificationsWhen: `, denn wenn Sie unterwegs sind und nur schnelle Lernbits wollen`,
quizWhen: `, wenn Sie für das Lernen volle Aufmerksamkeit schenken können, um Ihre Karten zu meistern`,
features: `Merkmale`,
ratings: `Bewertungen`,
notificationDailyCatchUpBody: `Neu: __, fällig: ___, studieren: ____, gelernt: _____, gemastet: ______`,
notificationDailyCatchUpTitle: `Täglicher Aufholung`,
reviewedJN: `Gerade jetzt überprüft`,
customUpdated: `Benutzerdefinierte Text aktualisiert`,
customTextField: `Synonyme, Beispiele usw.`,
field: `Feld`,
link: `Verknüpfung`,
backToParentCard: `Zurück zur Elternkarte`,
discard: `Verwerfen`,
failedImageLoad: `Stellen Sie das Image nicht geladen und stellen Sie sicher, dass Sie mit dem Internet verbunden sind`,
printDIYLabel: `DIY Ihr eigenes kreatives Papier -Basis -Studienaufbau, teilen Sie uns Ihre Kreation mit und erhalten Sie in der App.`,
reviewGraphChart: `Überprüfungsfrequenz`,
langNotSet: `Sprache nicht gesetzt`,
pronouncationLangInfo: `Um die Aussprache zu aktivieren, müssen Sie den Begriff und die Definitionssprache auswählen. Ein Sprecherschild erscheint neben den Sprachen, wenn Ihr Gerät diese Sprache unterstützt`,
clearFilters: `Klaren Filter`,
subFreeUnlimited: `Unbegrenzte Studyssätze, Karteikarten, Praktiken, Suche und Synchronisierung`,
customFields: `Benutzerdefinierte Felder`,
subLinks: `Kartenlinks`,
subPrint: `Druck / Studyset`,
subNotifications: `Benachrichtigung, bevor die App geöffnet werden muss`,
subCardsStudysets: `Karten / Studyset`,
subRevisionCycles: `Benutzerdefinierte Revisionszyklen`,
subscriptionHEnd: `Das Upgrade auf Profi zeigt uns, dass Sie unsere harte Arbeit wertvoll finden und uns Ermutigung und Kaffee verleihen, um sich weiter zu verbessern und neue erstaunliche Dinge zu schaffen.`,
subFree: `Frei`,
subPro: `Profi`,
guideSpacedRepetition: `Wie funktioniert die Wiederholung und Praxisstypen für die Wiederholung und Praxis?`,
guideSearch: `Suche & Filterung`,
guideSync: `Aktivieren Sie Backup und Synchronisierung auf Ihren Geräten`,
guidePronunciation: `Aussprachen aktivieren`,
guideImport: `Karten aus Quellen importieren`,
guideAccess: `Wer hat Zugriff auf meine Daten?`,
guideData: `Welche Daten sammeln wir?`,
guideContact: `Benötigen Sie Hilfe bei etwas anderem? Schreib uns`,
arrowStrength: `Stellen Sie fest, wie gut Sie diese Karte kennen`,
arrowImage: `Füge Bilder hinzu`,
arrowField: `Fügen Sie zusätzliche benutzerdefinierte Textfelder hinzu`,
arrowTag: `Tags anhängen`,
arrowStar: `Mark als Favorit`,
arrowLink: `Link zu anderen Karten`,
arrowGoal: `Richten Sie ein tägliches Bewertungsziel für sich selbst ein`,
arrowDue: `Studienwörter, die überprüft werden sollen`,
arrowNew: `Studienkarten, die noch nicht überprüft wurden`,
arrowMastered: `Wenn Sie keine fändigen oder neuen Karten haben, können Sie Mastered -Karten überprüfen, um sie beherrscht zu halten`,
arrowImport: `Importieren Sie Ihre vorhandenen Karteikarten`,
arrowNewCard: `Fügen Sie neue Karteikarten hinzu`,
dropboxStep1: `1. Holen Sie sich Access -Code von Dropbox, indem Sie sich anmelden`,
dropboxStep1Btn: `Melden Sie sich mit Dropbox an`,
dropboxStep2: `2. Geben Sie unten den Zugriffscode ein`,
dropboxStep2Input: `Code hier eingeben`,
dropboxStep3: `3. Synchronisieren Sie Synchronisation`,
alreadyLinked: `Bereits verknüpft, tippen Sie auf das Unglied`,
selectCardsToLink: `Wählen Sie Karten zum Verknüpfen aus`,
unsupportedLangP: `Wählen Sie eine Sprache aus, die die Aussprache aus den Einstellungen des Sets unterstützt`,
links: `Links`,
emailUs: `Senden Sie uns eine Email`,
whatsappUs: `WhatsApp uns`,
printMinHeight: `Mindest. Zeilenhöhe`,
exportType: `Dateityp exportieren`,
generateFileText: `Datei generieren`,
generatatingFile: `Datei generieren`,
verySmall: `Sehr klein`,
small: `Klein`,
normal: `Normal`,
big: `Groß`,
veryBig: `Sehr groß`,
repeatNTimes: `Wiederholen Sie __ mal`,
pause: `Pause`,
for: `zum`,
say: `Sagen`,
defShort: `Definitiv.`,
times: `mal`,
autoplayPreferences: `Setzen Sie die Autoplay -Einstellungen`,
autoPlay1: `Pause nach dem vorherigen Wort`,
autoPlay2: `Anzahl der Term -Pronounzierungen`,
autoPlay3: `Pause, bevor die Definition enthüllt`,
autoPlay4: `Anzahl der Definitionspressionen`,
autoPlay5: `Pause, bevor das nächste Wort angezeigt wird`,
autoPlay6: `Wiederholen Sie dieselbe FlashCard`,
startAutoPlay: `Autoplay starten`,
autoPlayOffConfirm: `Schalten Sie das Autoplay aus, um manuelle Steuerelemente zu aktivieren`,
turnOff: `Ausschalten`,
keepPn: `Mach weiter`,
foundIn: `Gefunden in __`,
repeat: `wiederholen`,
stop: `Stoppen`,
listenInBreak: `Wusstest du? Sie können Musik / Podcasts in Pausen hören`,
contextSearch: `Kontextsuche`,
contextSearchText: `Holen Sie sich Beispiele dafür, wie __ in verschiedenen Sätzen verwendet wird`,
transalteSearch: `Übersetzen`,
translateSearchText: `Übersetzen ins ___`,
synonymSearch: `Synonymsuche`,
synonymSearchText: `Suche nach Synonymen von __`,
selectToAdd: `Wählen Sie die Ergebnisse aus, die Sie dieser Karte hinzufügen möchten`,
addToCard: `Ausgewählt zur Karte hinzufügen`,
hideFromPractice: `Verstecken Sie sich in Runde`,
setLanguageRequired: `Bitte wählen Sie die Sprache der Begriffe und Definitionen in den Studyset -Details aus`,
fieldNeedsText: `Geben Sie vor der Suche etwas in dieses Feld ein`,
possibleDupe: `Mögliches Duplikat`,
loadNextXCards: `Last als nächstes __ Karten`,
repeatPractice: `Wiederholen Sie diese __ -Karten`,
keepScreenOnInfo: `Möglicherweise müssen Sie Ihre Auto-Lock-Einstellung einstellen, um den Bildschirm während des Autoplays einzuschalten.`,
siteLoginH2: `SFM -Konto`,
siteLoginP: `Sie können mit Ihren Flash -Karten ein einfaches Konto verwenden, um Ihre Karteikarten mit Ihren Freunden, Ihren Schülern oder der gesamten Community zu teilen.`,
logOut: `Ausloggen`,
logIn: `Einloggen`,
createAccount: `Neuen Account erstellen`,
signUp: `Anmeldung`,
username: `Nutzername`,
email: `Email`,
password: `Passwort`,
networkError: `Netzwerkfehler`,
fillAllDetails: `Bitte füllen Sie alle Details aus`,
noUserWithDetails: `Kein Benutzer mit den eingegebenen Details gefunden`,
userAlreadyExists: `Die angegebene E -Mail oder der Benutzername existiert bereits`,
signUpOrLoginToCont: `Melden Sie sich an oder melden Sie sich an, um fortzufahren?`,
atLeastOneCardToShare: `Mindestens eine Karte ist erforderlich, um zu teilen`,
publishingStudyset: `Veröffentlichungsstudyset`,
updatesDetected: `Möchten Sie feststellen, dass Sie die lokalen Daten aktualisieren möchten? (Gelöscht: __, aktualisiert: ___, neu: ____)`,
updatesApplied: `Aktualisierungen angewendet`,
alreadyUpToDate: `Schon aktuell`,
practiceTypeArrow: `Entdecken Sie verschiedene Methoden des Praktizierens`,
share: `Teilen`,
sharingModalIntro: `Teilen Sie Ihre Karteikarten in diesem Set mit Ihren Freunden, Ihren Schülern oder der gesamten Community.`,
whatIsShared: `Was wird geteilt`,
whatIsNotShared: `Was wird nicht geteilt`,
whatIsSharedText: `Setzen Sie den Namen, setzen Sie die Begriffssprache, definitonische Sprache, alle enthalten Karten mit Begriffen, Definitionen, benutzerdefinierten Textfeldern und Bildern`,
whatIsNotSharedText: `Alle Kartenstärken, Sterne, Links, Tags und Ihre Bewertungsgeschichte`,
checkForSharedUpdates: `Überprüfen Sie nach Updates von Creator`,
fetchUpdates: `Updates abrufen`,
youSharedStudyset: `Sie haben dieses Studyset geteilt`,
publishChanges: `Änderungen speichern und veröffentlichen`,
redeem: `Tilgen`,
noAds: `Keine Werbung`,
dupeDetection: `Doppelte Erkennung`,
coffeeFeature: `Kaffee, um uns zu helfen, mehr Funktionen zu entwickeln`,
shareLink: `Einen Link teilen`,
coffeeForUs: `Sie erhalten eine lebenslange Lizenz für nur __, die Emily 6 Kaffee, Dominik 3 Kaffees und Russ 3 Kaffee verleiht, die uns etwa 39 Stunden lang befeuern, um diese App -Veranstaltung besser zu machen`,
sharingCards: `Karten teilen`,
published: `Veröffentlicht`,
alreadyHaveAccount: `Sie haben bereits ein Konto?`,
notAlreadyHaveAccount: `Sie haben noch kein Konto?`,
startPractice: `Beginnen Sie bei der Übung`,
selectQuizTypes: `Wählen Sie Quiz -Typen`,
correct: `Richtig`,
incorrect: `Falsch`,
yes: `Ja`,
no: `Nein`,
levelSilver: `Silberspiegel __`,
levelGold: `Goldniveau __`,
levelPlatinum: `Platinspiegel __`,
levelDiamond: `Diamantspiegel __`,
levelJade: `Jade Level __`,
reviewsLeftGoal: `__ Bewertungen für das tägliche Ziel`,
dailyGoalAchieved: `Tägliches Ziel erreicht`,
share: `Teilen`,
rateApp: `Bewertungs App`,
allStats: `Alle Statistiken`,
reviewTimeError: `Zeitüberschreitung nach Fehler`,
reviewTimeCorrect: `Auszeit nach rechts`,
pronounceTermAfterReview: `Begriff nach der Überprüfung aussprechen`,
pronounceDefinitionAfterReview: `Definition nach Überprüfung aussprechen`,
practice: `Trainieren`,
notificationsScheduledInfo: `__ Es wurden Benachrichtigungen geplant, Sie können die App jetzt schließen`,
wellDone: `Gut erledigt`,
keepItUp: `Mach weiter`,
youRock: `Du rockst`,
niceOne: `Schön`,
lnSelect: `Sprache auswählen`,
sampleData: `Keine Bewertungen, die Beispieldaten zeigen`,
reviewFreq: `Überprüfungsfrequenz`,
selectPractice: `Übung: Select`,
spellPractice: `Übung: Zauber`,
connectPractice: `Übung: Verbinden`,
languages: `Sprachen`,
languagesPairs: `Sprachpaare`,
shareArrow: `Teilen Sie Set mit Freunden, Schülern oder der gesamten Community`,
cardsPerRound: `Karten / Runde`,
showAll: `Zeige alles`,
supportedLangsVary: `Unterstützte Sprachen variieren`,
practiceWithoutSave: `Übe nicht gerettet`,
practiceWithoutSaveBody: `Sie haben dieses Studyset Ihrer Sammlung nicht hinzugefügt. Möchten Sie ihn jetzt hinzufügen, um Ihren Studienfortschritt zu sparen?`,
saveSetNow: `Speichern Sie Karten vor Ihrer Sammlung`,
continueWithoutSaveSave: `Beginnen Sie das Üben ohne Speichern`,
createdBy: `Erstellt von`,
setSavedToYourCollection: `Studiensatz in Ihrer Sammlung gespeichert`,
accountBackupDisclaimer: `Bitte beachten Sie, dass dieses Konto nur zum gemeinsamen Teilen von Studysets mit anderen verwendet werden kann und nicht zum Sichern oder Synchronisieren Ihrer Studysets oder Karteikarten verwendet werden kann. Um alle Ihre Daten zu synchronisieren und zu sichern`,
syncEnabled: `Die Synchronisation aktiviert, wobei Sie Ihren Inhalt in Arbeit abrufen`,
searchAllSets: `Suchstudiensätze von anderen Benutzern`,
anyLanguage: `Jede Sprache`,
trendingIn: `Trendung in`,
manualBackups: `Handbuch Backup`,
manualBackupCreate: `Erstellen Sie manuelle Sicherung`,
confirmManualImport: `Sind Sie sicher, dass Sie alle aktuellen Daten durch diese Sicherung ersetzen möchten? Dies wird nur auf neuen Geräten ohne Daten empfohlen`,
importFromManualBackup: `Importieren aus dem backup`,
imgOfflineSets: `Auto-Download-Bilder zum Offline-Lernen herunterladen`,
unsupportedDeviceCache: `Diese Funktion ist nur in der iOS- oder Android -App erhältlich`,
shareChanges: `Teilen __ Änderungen`,
publiclySearchable: `Durch Benutzer durchsuchbar`,
description: `Beschreibung`,
restoreFromDropboxBackup: `Wiederherstellen von Dropbox Backup`,
imageCacheStudysetSub: `[Nur iOS & Android] Laden Sie das Bild zum Offline -Studium herunter`,
keywordsOrLangNeeded: `Sie müssen einige Schlüsselwörter oder eine Sprache eingeben`,
dropboxAlreadyLinked: `Dropbox -Konto ist bereits verknüpft`,
noSetUpdateAccess: `Sie haben keinen Zugriff, um diesen Studiensatz zu bearbeiten.`,
confirmSetOwnerLogin: `Wenn Sie sicher sind, dass Sie der Eigentümer sind, versuchen Sie, sich erneut in Ihrem Konto anzumelden.`,
uninitedRestriction: `Um Ihren Fortschritt zu speichern, müssen Sie zuerst diesen Studyset zu Ihrer Sammlung hinzufügen`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Die Speicherung nicht konsolidieren`,
consolidateStorageDone: `Speicherkonsolidierung, erlauben Sie bitte bis zu einer Stunde für Dropbox, um alte Dateien zu entfernen, bevor Sie sich auf einem neuen Gerät anmelden.`,
consolidatingStorage: `Konsolidierung der Lagerung ...`,
deleteAccount: `Konto löschen`,
consolidateStorageDescription: `In diesem Vorgang wird Ihre Sicherungsdateien wiedergearbeitet, sodass das Einrichten eines neuen Geräte schneller ist`,
consolidatingStorageConfirm: `Stellen Sie sicher, dass alle Ihre Änderungen bereits die Synchronisierung beendet haben. Synchronisieren Sie andere Geräte, während dieser Vorgang stattfindet. Möchtest du weiter machen?`,
consolidateStorage: `Speicherkonsolidierung`,


}